import styled from 'styled-components'

export const StyledGlobalMainContainer = styled.div`
	padding: 0 150px;
	max-width: 1440px;
	display: grid;
	align-items: center;
	margin: 0 auto;
	margin-top: ${props => props.marginTop && props.marginTop};
	box-sizing: border-box;
	@media (max-width: 1440px) {
		padding-left: 22px;
		padding-right: 22px;
	}
`
